/**
 * @file CrossfitSection.tsx
 * @summary Section page d'accueil — CrossfitSection
 *
 * Bloc de contenu affiché sur la home (`/`). Composant présentationnel utilisant les tokens du design system (Charbon/Or, Bebas Neue/Inter).
 *
 * @see docs/07-CODEBASE.md — conventions de code
 * @see docs/02-FRONTEND.md — design system (tokens HSL, typographie)
 */
import Section from "@/components/Section";
import { Dumbbell, Heart, Zap } from "lucide-react";

const pillars = [
  { icon: Dumbbell, title: "Haltérophilie", desc: "Développe ta force avec des mouvements techniques et fonctionnels" },
  { icon: Heart, title: "Gymnastique", desc: "Maîtrise ton corps avec des mouvements au poids de corps, à la barre et aux anneaux" },
  { icon: Zap, title: "Cardio", desc: "Repousse tes limites cardiovasculaires avec des WODs intenses et variés" },
  { icon: Dumbbell, title: "Renforcement musculaire", desc: "Construis une base solide grâce à des exercices ciblés pour gagner en force et en endurance" },
];

export default function CrossfitSection() {
  return (
    <Section id="crossfit">
      <div className="text-center mb-12">
        <span className="inline-block text-sm font-semibold text-gold tracking-wider mb-2 font-body normal-case">Entraînement complet</span>
        <h2 className="text-4xl md:text-5xl text-foreground">Le CrossFit, c'est quoi ?</h2>
      </div>

      <p className="text-center max-w-2xl mx-auto text-muted-foreground leading-relaxed mb-12 font-body normal-case">
        Le CrossFit est une méthode d'entraînement complète qui combine haltérophilie, gymnastique et cardio. 
        Chaque séance repose sur trois principes : <strong className="text-foreground">mouvements fonctionnels</strong>, 
        <strong className="text-foreground"> variété constante</strong> et <strong className="text-foreground">intensité adaptée</strong> à ton niveau. 
        <br />Débutant ou confirmé, tu progresses à ton rythme
      </p>

      <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 mb-16">
        {pillars.map((p) => (
          <div key={p.title} className="bg-card border border-border rounded-lg p-8 text-center hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group">
            <div className="w-14 h-14 rounded-full bg-gold/10 flex items-center justify-center mx-auto mb-4 group-hover:bg-gold/20 transition-colors">
              <p.icon className="text-gold" size={28} />
            </div>
            <h3 className="text-2xl mb-2 text-foreground">{p.title}</h3>
            <p className="text-muted-foreground text-sm font-body normal-case">{p.desc}</p>
          </div>
        ))}
      </div>

    </Section>
  );
}